import * as actionTypes from './actionTypes';

export const getDeclarations = (payload) => ({ type: actionTypes.GET_DECLARATIONS, payload });
export const getDeclarationsSuccess = (payload) => ({
  type: actionTypes.GET_DECLARATIONS_SUCCESS,
  payload,
});
export const getDeclarationsError = (payload) => ({
  type: actionTypes.GET_DECLARATIONS_FAILURE,
  payload,
});

export const getHistory = (payload) => ({ type: actionTypes.GET_HISTORY, payload });
export const getHistorySuccess = (payload) => ({ type: actionTypes.GET_HISTORY_SUCCESS, payload });
export const getHistoryError = (payload) => ({ type: actionTypes.GET_HISTORY_FAILURE, payload });
export const removeHistoryDeclaration = (payload) => ({
  type: actionTypes.REMOVE_HISTORY_DECLARATION,
  payload,
});

export const clarifyDeclaration = (payload) => ({ type: actionTypes.CLARIFY_DECLARATION, payload });
export const clarifyDeclarationSuccess = (payload) => ({
  type: actionTypes.CLARIFY_DECLARATION_SUCCESS,
  payload,
});
export const clarifyDeclarationError = (payload) => ({
  type: actionTypes.CLARIFY_DECLARATION_FAILURE,
  payload,
});

export const resendDeclaration = (payload) => ({ type: actionTypes.RESEND_DECLARATION, payload });
export const resendDeclarationSuccess = (payload) => ({
  type: actionTypes.RESEND_DECLARATION_SUCCESS,
  payload,
});
export const resendDeclarationError = (payload) => ({
  type: actionTypes.RESEND_DECLARATION_FAILURE,
  payload,
});

export const getDeclarationDocuments = (cardId, type) => ({
  type: actionTypes.GET_DOCUMENTS,
  payload: { cardId, type },
});
export const getDeclarationDocumentsSuccess = (cardId, data) => ({
  type: actionTypes.GET_DOCUMENTS_SUCCESS,
  payload: { cardId, data },
});
export const getDeclarationDocumentsError = (cardId, error) => ({
  type: actionTypes.GET_DOCUMENTS_FAILURE,
  payload: { cardId, error },
});

export const getPropertyDeductionBalance = (payload) => ({
  type: actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE,
  payload,
});
export const getPropertyDeductionBalanceSuccess = (payload) => ({
  type: actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE_SUCCESS,
  payload,
});
export const getPropertyDeductionBalanceError = (payload) => ({
  type: actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE_FAILURE,
  payload,
});
